"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var BasicDialog_1 = require("../Dialog/BasicDialog");
var ErrorMessageBox_1 = __importDefault(require("./ErrorMessageBox"));
var react_i18next_1 = require("react-i18next");
/**
 * Component that manages the display of error messages. Can be configured to display a dialog, a message box, or neither.
 *
 * @param mode determines whether to display a dialog, a message box, or neither
 * @param onClose function to call when the close/dismiss button is clicked
 * @param error error text to display
 * @param dialogConfig configuration for the error dialog
 * @param dialogConfig.title text to show in the title of the dialog
 * @param dialogConfig.dismissLabel text to show in the close button
 * @param dialogConfig.sx sx styles passed to the underlying root(Dialog) component
 * @param messageBoxConfig configuration for the error message box
 * @param messageBoxConfig.dismissible whether the message box can be dismissed
 * @param messageBoxConfig.position determines whether the message box should be displayed at the top or bottom of the screen
 * @param messageBoxConfig.fontColor the font color of the text inside the message box
 * @param messageBoxConfig.backgroundColor the background color of the message box
 * @param messageBoxConfig.sx sx styles passed to the underlying root(Box) component
 *
 * @category Component
 */
var ErrorManager = function (props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var children = props.children, _a = props.mode, mode = _a === void 0 ? 'dialog' : _a, title = props.title, _b = props.error, error = _b === void 0 ? '' : _b, _c = props.onClose, onClose = _c === void 0 ? function () { } : _c, dialogConfig = props.dialogConfig, _d = props.messageBoxConfig, messageBoxConfig = _d === void 0 ? {
        position: 'top',
    } : _d;
    var ErrorDialogWithProps = (0, react_1.useCallback)(function () {
        var _a, _b;
        return (react_1.default.createElement(BasicDialog_1.BasicDialog, { open: error.length > 0, title: (_b = (_a = dialogConfig === null || dialogConfig === void 0 ? void 0 : dialogConfig.title) !== null && _a !== void 0 ? _a : title) !== null && _b !== void 0 ? _b : t('bluiCommon:MESSAGES.ERROR'), body: t(error), onClose: onClose, dismissButtonText: dialogConfig === null || dialogConfig === void 0 ? void 0 : dialogConfig.dismissLabel, sx: dialogConfig === null || dialogConfig === void 0 ? void 0 : dialogConfig.sx }));
    }, [dialogConfig, title, error, onClose, t]);
    var ErrorMessageBoxWithProps = (0, react_1.useCallback)(function () {
        var _a, _b;
        var _c = messageBoxConfig.dismissible, dismissible = _c === void 0 ? true : _c, fontColor = messageBoxConfig.fontColor, backgroundColor = messageBoxConfig.backgroundColor, sx = messageBoxConfig.sx;
        return (react_1.default.createElement(ErrorMessageBox_1.default, { title: (_b = (_a = messageBoxConfig === null || messageBoxConfig === void 0 ? void 0 : messageBoxConfig.title) !== null && _a !== void 0 ? _a : title) !== null && _b !== void 0 ? _b : t('bluiCommon:MESSAGES.ERROR'), errorMessage: t(error), dismissible: dismissible, sx: sx, backgroundColor: backgroundColor, fontColor: fontColor, onClose: onClose }));
    }, [error, title, t, messageBoxConfig, onClose]);
    return mode === 'dialog' && error.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        react_1.default.createElement(ErrorDialogWithProps, null))) : mode === 'message-box' && error.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        messageBoxConfig.position !== 'bottom' && react_1.default.createElement(ErrorMessageBoxWithProps, null),
        children,
        messageBoxConfig.position === 'bottom' && react_1.default.createElement(ErrorMessageBoxWithProps, null))) : (react_1.default.createElement(react_1.default.Fragment, null, children));
};
exports.default = ErrorManager;
